import type { TFunction } from "i18next";
import type { ConfirmContextValue } from "../shell/emailBuilderConfirmTypes";
import { findGroup } from "../domain/find";
import type { EmailDocument, Selection } from "../domain/types";
import { ungroupConfirmOptions } from "./confirmDelete";

type UngroupSelectionActions = {
  ungroup: (groupId: string) => void;
};

export async function ungroupSelectionWithConfirm(
  document: EmailDocument,
  selection: Selection,
  { confirm }: Pick<ConfirmContextValue, "confirm">,
  actions: UngroupSelectionActions,
  t: TFunction,
): Promise<void> {
  if (selection.kind !== "group") {
    return;
  }

  const group = findGroup(document.sections, selection.groupId);
  if (!group) {
    return;
  }

  const confirmed = await confirm(ungroupConfirmOptions(t));
  if (!confirmed) {
    return;
  }

  actions.ungroup(selection.groupId);
}
